import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './css/Address.scss';

@injectIntl
export default class Address extends Component {
    static propTypes = {
        hideBillingAdress: PropTypes.bool,
        intl: intlShape,
        location: ImmutablePropTypes.map.isRequired,
    }

    renderLocation() {
        const { location } = this.props;
        return location && (
            <address className={styles.section}>
                <div className={styles.headingContainer}>
                    <h4 className={styles.heading}>
                        <FormattedMessage id='frontend.form_selector_shipping.label.number' />
                        {' #'}{location.get('number')}
                        {location.get('old_number') && (
                            <small>( {location.get('old_number')})</small>
                        )}
                    </h4>
                </div>
                <ul className={styles.details}>
                    <li>
                        {location.getIn(['address', 'organization'])}
                    </li>
                    <li>
                        {location.get('contact')}
                    </li>
                    <li>
                        {location.get('tax_number')}
                    </li>
                    <li>
                        {location.get('cost_center')}
                    </li>
                    <li>
                        {location.getIn(['address', 'phone'])}
                    </li>
                    <li>
                        {location.getIn(['address', 'email'])}
                    </li>
                </ul>
            </address>
        );
    }

    renderLocationAddress() {
        const { location } = this.props;
        const address = location.get('address');

        return address && (
            <address className={styles.section}>
                <div className={styles.headingContainer}>
                    <h4 className={styles.heading}>
                        <FormattedMessage
                            id='frontend.addressbook.headline.shipping'
                        />
                    </h4>
                </div>
                <ul className={styles.details}>
                    <li>{location.getIn(['address', 'organization'])}</li>
                    <li>{location.get('info')}</li>
                    <li>{address.get('street')}</li>
                    {address.get('building') && (
                        <li>
                            <FormattedMessage id='frontend.form_selector_shipping.label.building' />
                            {address.get('building')}
                        </li>
                    )}
                    <li>{address.get('zip')} {address.get('city')}</li>
                </ul>
            </address>
        );
    }

    renderBillingAddress() {
        const { location } = this.props;
        const address = location.get('address');
        const billing = location.get('billing');

        if (!billing) {
            return (
                <address className={styles.section}>
                    <div className={styles.headingContainer}>
                        <h4 className={styles.heading}>
                            <FormattedMessage id='frontend.addressbook.headline.billing' />
                        </h4>
                    </div>
                    <FormattedMessage id='frontend.addressbook.text.billing_identical' />
                </address>
            );
        }

        return (
            <address className={styles.section}>
                <div className={styles.headingContainer}>
                    <h4 className={styles.heading}>
                        <FormattedMessage id='frontend.addressbook.headline.billing' />
                    </h4>
                </div>
                <ul className={styles.details}>
                    <li>{billing.getIn(['address', 'organization'])}</li>
                    <li>{billing.getIn(['address', 'contact'])}</li>
                    <li>{billing.getIn(['address', 'street'])}</li>
                    {billing.getIn(['address', 'building']) && (
                        <li>
                            <FormattedMessage id='frontend.addressbook.label.building' />
                            {billing.getIn(['address', 'building'])}
                        </li>
                    )}
                    <li>{billing.getIn(['address', 'zip'])} {billing.getIn(['address', 'city'])}</li>
                </ul>
            </address>
        );
    }

    render() {
        const { location } = this.props;
        if (!location) return null;

        return (
            <div className={styles.wrapper}>
                <div className={styles.sections}>
                    {this.renderLocation()}
                    {this.renderLocationAddress()}
                    {this.renderBillingAddress()}
                </div>
            </div>
        );
    }
}
